<template>
  <div class="historyMsg">
    <div class="mapMsg">
      <div class="selectBox">
        <div class="selectBoxL">
          <el-form :inline="true" :model="exportData" class="demo-form-inline">
            <template>
              <el-form-item label="选择查询类别:">
                <el-select
                  @change="
                    exportData.value = '';
                    exportData.label = '';
                    getyearANDcollege();
                  "
                  v-model="tabletype"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeoptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="选择查看年份:">
                <el-select
                  @change="
                    tags = [];
                    exportData.value = '';
                    onSelectTable('year', exportData.label);
                    getyearANDcollege(exportData.label);
                  "
                  no-data-text="请先选择查询类别"
                  v-model="exportData.label"
                  placeholder="录取年份筛选"
                >
                  <el-option
                    v-for="item in year"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="-">
                <!-- <el-select v-model="exportData.condition" placeholder="请选择">
                <el-option label=">" value="0"> </el-option>
                <el-option label="=" value="1"> </el-option>
                <el-option label="<" value="2"> </el-option>
              </el-select> -->
              </el-form-item>
              <el-form-item label="选择查看院系:">
                <el-select
                  @change="onSelectTable('CollegeName', exportData.value)"
                  no-data-text="请先选择查询年份"
                  v-model="exportData.value"
                  placeholder="录取院系筛选"
                >
                  <el-option
                    v-for="(item, i) in college"
                    :key="i"
                    :label="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <!-- <el-button type="primary" @click="selectHistory"
                  >筛选</el-button
                > -->
                <!-- <el-button
                  type="primary"
                  plain
                  @click="
                    tags = [];
                    selectHistory();
                    exportData.label = exportData.value = '';
                  "
                  >清空筛选</el-button
                > -->
              </el-form-item>
            </template>
          </el-form>
        </div>
      </div>
      <div class="Datatable">
        <el-table
          :data="tableData.data"
          v-loading="loading"
          ref="appTable"
          border
          empty-text="暂无数据"
        >
          <el-table-column
            v-for="(tablelist, dd) in tableData.tableTitle"
            :label="tablelist.label"
            :prop="tablelist.value"
            :key="tablelist.value"
          >
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] }}
            </template>
          </el-table-column>
        </el-table>
            <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          @prev-click="changePage"
          @next-click="changePage"
          @current-change="changePage"
          :style="{marginTop:'20px'}"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tags: [],
      exportData: {
        label: "",
        value: "",
      },
      tableData: [],
      loading: false,
      drawer: false,
      value: "",
      options: [],
      tabletype: "",
      college: [],
      year: [],
      typeoptions: [
        { key: 1, value: "硕士" },
        { key: 2, value: "博士" },
      ],
      // 最大页数
      pageCount: 0,
      pageIndex: 1,
    };
  },
  mounted() {
    //获取跳转信息type 1 硕士 2博士 4成人
    // this.tabletype = window.location.href.split("type=")[1];
    // this.selectHistory();
  },
  methods: {
    // 查询历年录取信息
    selectHistory() {
      let searcharry = [];
      if (this.tags) {
        // 取出查询条件key .value
        this.tags.forEach((el) => {
          searcharry.push({ key: el.key, value: el.value });
        });
        searcharry = JSON.stringify(searcharry);
        console.log(searcharry);
      }

      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/HistoryData/AdultEduList`,
        params: {
          searcharry: searcharry,
          tabletype: this.tabletype,
          pageindex: this.pageIndex,
        pageSize: 10,
        },
      })
        .then((res) => {
          console.log(res);

          this.tableData = res.data.response;
  this.pageCount = res.data.response.pageCount;
          this.loading = false;
        })
        .catch((_) => {});
    },
    // 删除条件标签
    delTableTag(tag) {
      // console.log(tag);
      this.tags.splice(tag, 1);
      this.selectHistory();
    },
    // 选择筛选条件  将条件打包成数组
    onSelectTable(key, label) {
      this. pageCount=0;
            this.pageIndex= 1
      if (key == "CollegeName") {
        this.tags[0]=({
          key: "CollegeName",
          value: label,
        });
      } else if (key == "year") {
        this.tags[1]=({
          key: "year",
          value: label,
        });
      }
console.log( this.tags)
      this.selectHistory();
    },
    //获取年份
    getyearANDcollege(value) {
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/HistoryData/selectvalue`,
        params: {
          tabletype: this.tabletype,
          year: this.exportData.label,
        },
      })
        .then((res) => {
          console.log(res);
          if (this.exportData.label) {
            this.college = res.data.response;
          } else {
            this.tags = [];
            this.tableData = [];
            this.year = res.data.response;
          }
        })
        .catch((_) => {});
    },
      // 切换分页
    changePage(index) {
      console.log(index);
      this.pageIndex = index;
      this.selectHistory();
    },
  },
};
</script>
<style>
.historyMsg {
  width: 100%;
  height: 100vh;
  /* overflow: hidden; */
}

.mapMsg {
  float: right;
  width: 100%;
  height: 100vh;
  overflow-x: auto;
}

.moreBtn {
  cursor: pointer;
  margin: 15px 0px;
  height: 60px;
  font-size: 16px;
  line-height: 60px;
  color: #cacaca;
  font-weight: 600;
  background: linear-gradient(
    90deg,
    rgba(239, 243, 246, 1) 0%,
    rgba(243, 246, 248, 0.5) 50.33%,
    rgba(253, 254, 254, 0.05) 95.39%,
    rgba(255, 255, 255, 0) 100%
  );
}
.selectBox {
  margin: 30px 20px;
  height: auto;
  width: 100%;
}
.Datatable {
  margin: 30px auto 0px;
  width: 90%;
  min-width: 415px;
}
.dialogTable {
  margin: 20px 0px;
}
.selectBoxR {
  /* float: left;  */
}
.selectBoxL {
  /* float: left; */
}
.condictionTag {
  margin: 10px 0px 0px 10px;
}
</style>